<script setup>
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import Navigation from '@/components/Nav.vue'
  import Reminder from '@/components/Reminder.vue'
  import { useUserStore } from '@/stores/user';

  const userStore = useUserStore();
  const route = useRoute();
  const isLoginPage = computed(() => route.name === 'Login');

  const themeClass = computed(() => `theme--${userStore.preferences.ui.theme}`);
  const densityClass = computed(() => `density--${userStore.preferences.ui.density}`);
</script>
<!-- version 0.95 -->
<template>
  <div :class="[themeClass, densityClass]">
    <navigation v-if="!isLoginPage"></navigation>
    <router-view></router-view>
  </div>
</template>

<style lang="scss">
  @use '@/scss/style.scss';

    .theme--dark {
      background: #0f1115;
      color: #eee;
      // min-height: 100vh;
    }
  
    .theme--light {
      background: #f5f6f8;
      color: #111;
      min-height: 100vh;
    }
  
    .density--compact {
      font-size: 0.92rem;
    }
  
    .density--comfortable {
      font-size: 1rem;
    }
</style>